import { createFeatureSelector, createSelector } from '@ngrx/store'
import { WIDGET_PAGES_FEATURE_KEY, WidgetPagesState, widgetPagesAdapter } from './widget-pages.reducer'

export const selectWidgetPagesState = createFeatureSelector<WidgetPagesState>(WIDGET_PAGES_FEATURE_KEY)

const { selectAll, selectEntities } = widgetPagesAdapter.getSelectors()

export const selectWidgetPagesLoaded = createSelector(selectWidgetPagesState, (state: WidgetPagesState) => state.loaded)

export const selectAllWidgetPages = createSelector(selectWidgetPagesState, (state: WidgetPagesState) =>
  selectAll(state),
)

export const selectWidgetPagesEntities = createSelector(selectWidgetPagesState, (state: WidgetPagesState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectWidgetPagesState, (state: WidgetPagesState) => state.selectedId)

export const selectOldWidgets = createSelector(selectWidgetPagesState, (state: WidgetPagesState) => state.oldWidgets)

export const selectEntity = createSelector(selectWidgetPagesEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectEditCreateWidgetPageLoaded = createSelector(
  selectWidgetPagesState,
  (state: WidgetPagesState) => state.editCreateWidgetPageLoaded,
)
